/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * DynamicWheel
 * Stock-only NTAW feed. Credentials never appear in responses.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DwcConnection,
  DwcConnectionInput,
  DwcDiagnosticAccess,
  DwcDiagnosticResult,
  DwcLocation,
  DwcRun,
  DwcSyncInput,
  DwcTestResult
} from './models';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetDwcDiagnosticAccessUrl = () => {


  

  return `/api/dynamic-wheel/diagnostics/access`
}

export const getDwcDiagnosticAccess = async ( options?: RequestInit): Promise<DwcDiagnosticAccess> => {
  
  return customFetch<DwcDiagnosticAccess>(getGetDwcDiagnosticAccessUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetDwcDiagnosticAccessQueryKey = () => {
    return [
    `/api/dynamic-wheel/diagnostics/access`
    ] as const;
    }

    
export const getGetDwcDiagnosticAccessQueryOptions = <TData = Awaited<ReturnType<typeof getDwcDiagnosticAccess>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDwcDiagnosticAccess>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDwcDiagnosticAccessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDwcDiagnosticAccess>>> = ({ signal }) => getDwcDiagnosticAccess({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDwcDiagnosticAccess>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDwcDiagnosticAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getDwcDiagnosticAccess>>>
export type GetDwcDiagnosticAccessQueryError = ErrorType<unknown>



export function useGetDwcDiagnosticAccess<TData = Awaited<ReturnType<typeof getDwcDiagnosticAccess>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDwcDiagnosticAccess>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDwcDiagnosticAccessQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Operator-only, read-only outbound-IP and DEV stock check. No saved merchant credentials or Shopify calls.
 */
export const getRunDwcDiagnosticUrl = () => {


  

  return `/api/dynamic-wheel/diagnostics/run`
}

export const runDwcDiagnostic = async ( options?: RequestInit): Promise<DwcDiagnosticResult> => {
  
  return customFetch<DwcDiagnosticResult>(getRunDwcDiagnosticUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getRunDwcDiagnosticMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runDwcDiagnostic>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runDwcDiagnostic>>, TError,void, TContext> => {

const mutationKey = ['runDwcDiagnostic'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runDwcDiagnostic>>, void> = () => {
          

          return  runDwcDiagnostic(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RunDwcDiagnosticMutationResult = NonNullable<Awaited<ReturnType<typeof runDwcDiagnostic>>>
    
    export type RunDwcDiagnosticMutationError = ErrorType<void>

    export const useRunDwcDiagnostic = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runDwcDiagnostic>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runDwcDiagnostic>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRunDwcDiagnosticMutationOptions(options));
    }
    
export const getGetDwcConnectionsUrl = () => {


  

  return `/api/dynamic-wheel/connections`
}

export const getDwcConnections = async ( options?: RequestInit): Promise<DwcConnection[]> => {
  
  return customFetch<DwcConnection[]>(getGetDwcConnectionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetDwcConnectionsQueryKey = () => {
    return [
    `/api/dynamic-wheel/connections`
    ] as const;
    }

    
export const getGetDwcConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof getDwcConnections>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDwcConnections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDwcConnectionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDwcConnections>>> = ({ signal }) => getDwcConnections({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDwcConnections>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDwcConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getDwcConnections>>>
export type GetDwcConnectionsQueryError = ErrorType<unknown>



export function useGetDwcConnections<TData = Awaited<ReturnType<typeof getDwcConnections>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDwcConnections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDwcConnectionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getSaveDwcConnectionUrl = () => {


  

  return `/api/dynamic-wheel/connections`
}

export const saveDwcConnection = async (dwcConnectionInput: DwcConnectionInput, options?: RequestInit): Promise<DwcConnection> => {
  
  return customFetch<DwcConnection>(getSaveDwcConnectionUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dwcConnectionInput,)
  }
);}
  



export const getSaveDwcConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveDwcConnection>>, TError,{data: BodyType<DwcConnectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveDwcConnection>>, TError,{data: BodyType<DwcConnectionInput>}, TContext> => {

const mutationKey = ['saveDwcConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveDwcConnection>>, {data: BodyType<DwcConnectionInput>}> = (props) => {
          const {data} = props ?? {};

          return  saveDwcConnection(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SaveDwcConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof saveDwcConnection>>>
    export type SaveDwcConnectionMutationBody = BodyType<DwcConnectionInput>
    export type SaveDwcConnectionMutationError = ErrorType<unknown>

    export const useSaveDwcConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveDwcConnection>>, TError,{data: BodyType<DwcConnectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveDwcConnection>>,
        TError,
        {data: BodyType<DwcConnectionInput>},
        TContext
      > => {
      return useMutation(getSaveDwcConnectionMutationOptions(options));
    }
    
export const getGetDwcLocationsUrl = (id: string,) => {


  

  return `/api/dynamic-wheel/connections/${id}/locations`
}

export const getDwcLocations = async (id: string, options?: RequestInit): Promise<DwcLocation[]> => {
  
  return customFetch<DwcLocation[]>(getGetDwcLocationsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetDwcLocationsQueryKey = (id: string,) => {
    return [
    `/api/dynamic-wheel/connections/${id}/locations`
    ] as const;
    }

    
export const getGetDwcLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getDwcLocations>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDwcLocations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDwcLocationsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDwcLocations>>> = ({ signal }) => getDwcLocations(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDwcLocations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDwcLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getDwcLocations>>>
export type GetDwcLocationsQueryError = ErrorType<unknown>



export function useGetDwcLocations<TData = Awaited<ReturnType<typeof getDwcLocations>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDwcLocations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDwcLocationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getTestDwcConnectionUrl = (id: string,) => {


  

  return `/api/dynamic-wheel/connections/${id}/test`
}

export const testDwcConnection = async (id: string, options?: RequestInit): Promise<DwcTestResult> => {
  
  return customFetch<DwcTestResult>(getTestDwcConnectionUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getTestDwcConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testDwcConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testDwcConnection>>, TError,{id: string}, TContext> => {

const mutationKey = ['testDwcConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testDwcConnection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  testDwcConnection(id,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type TestDwcConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof testDwcConnection>>>
    
    export type TestDwcConnectionMutationError = ErrorType<unknown>

    export const useTestDwcConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testDwcConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testDwcConnection>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getTestDwcConnectionMutationOptions(options));
    }
    
export const getPreviewDwcConnectionUrl = (id: string,) => {


  

  return `/api/dynamic-wheel/connections/${id}/preview`
}

export const previewDwcConnection = async (id: string, options?: RequestInit): Promise<DwcRun> => {
  
  return customFetch<DwcRun>(getPreviewDwcConnectionUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getPreviewDwcConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewDwcConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewDwcConnection>>, TError,{id: string}, TContext> => {

const mutationKey = ['previewDwcConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewDwcConnection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  previewDwcConnection(id,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PreviewDwcConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof previewDwcConnection>>>
    
    export type PreviewDwcConnectionMutationError = ErrorType<unknown>

    export const usePreviewDwcConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewDwcConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewDwcConnection>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPreviewDwcConnectionMutationOptions(options));
    }
    
export const getStartDwcSyncUrl = (id: string,) => {


  

  return `/api/dynamic-wheel/connections/${id}/sync`
}

export const startDwcSync = async (id: string,
    dwcSyncInput: DwcSyncInput, options?: RequestInit): Promise<DwcRun> => {
  
  return customFetch<DwcRun>(getStartDwcSyncUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dwcSyncInput,)
  }
);}
  



export const getStartDwcSyncMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDwcSync>>, TError,{id: string;data: BodyType<DwcSyncInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startDwcSync>>, TError,{id: string;data: BodyType<DwcSyncInput>}, TContext> => {

const mutationKey = ['startDwcSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startDwcSync>>, {id: string;data: BodyType<DwcSyncInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  startDwcSync(id,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type StartDwcSyncMutationResult = NonNullable<Awaited<ReturnType<typeof startDwcSync>>>
    export type StartDwcSyncMutationBody = BodyType<DwcSyncInput>
    export type StartDwcSyncMutationError = ErrorType<unknown>

    export const useStartDwcSync = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDwcSync>>, TError,{id: string;data: BodyType<DwcSyncInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startDwcSync>>,
        TError,
        {id: string;data: BodyType<DwcSyncInput>},
        TContext
      > => {
      return useMutation(getStartDwcSyncMutationOptions(options));
    }
    
export const getGetDwcRunsUrl = (id: string,) => {


  

  return `/api/dynamic-wheel/connections/${id}/runs`
}

export const getDwcRuns = async (id: string, options?: RequestInit): Promise<DwcRun[]> => {
  
  return customFetch<DwcRun[]>(getGetDwcRunsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetDwcRunsQueryKey = (id: string,) => {
    return [
    `/api/dynamic-wheel/connections/${id}/runs`
    ] as const;
    }

    
export const getGetDwcRunsQueryOptions = <TData = Awaited<ReturnType<typeof getDwcRuns>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDwcRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDwcRunsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDwcRuns>>> = ({ signal }) => getDwcRuns(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDwcRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDwcRunsQueryResult = NonNullable<Awaited<ReturnType<typeof getDwcRuns>>>
export type GetDwcRunsQueryError = ErrorType<unknown>



export function useGetDwcRuns<TData = Awaited<ReturnType<typeof getDwcRuns>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDwcRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDwcRunsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





